import { render, staticRenderFns } from "./VacantBedAdjustment.vue?vue&type=template&id=346b43d2&"
import script from "./VacantBedAdjustment.vue?vue&type=script&lang=js&"
export * from "./VacantBedAdjustment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports